import { useState } from 'react';
import { unwrapLink, upsertLink } from '@platejs/link';
import type { SlateEditor } from 'platejs';

import { options } from 'common/components/ContentEditor/options';
import { getSafeLinkUrl } from 'common/components/ContentEditor/utils/editorHelpers';

/** Shared open/prefill/submit state for the link insert-or-edit dialog. */
export const useLinkDialogState = (editor: SlateEditor) => {
    const [open, setOpen] = useState(false);
    const [initialValue, setInitialValue] = useState<string | undefined>();

    const onTrigger = () => {
        const [linkEntry] = editor.api.nodes({
            match: { type: options.link.type },
        });
        const { url } = (linkEntry?.[0] as { url?: string }) || {};

        setInitialValue(url);
        setOpen(true);
    };

    const onClose = () => setOpen(false);

    const onSubmit = (url: string) => {
        const safeUrl = getSafeLinkUrl(url);

        if (!safeUrl) {
            unwrapLink(editor);
        } else {
            // The dialog already validated this value. upsertLink would
            // otherwise re-check against the plugin's stricter isUrl and
            // silently discard a relative or mailto url.
            upsertLink(editor, { url: safeUrl, skipValidation: true });
        }

        setOpen(false);
    };

    return { open, initialValue, onTrigger, onClose, onSubmit };
};
